import type { EventType } from '@api/EventsApi';

export function isWorkshop(eventType: EventType): boolean {
	return ['virtual_workshop', 'physical_workshop'].includes(eventType);
}

export function isEvent(eventType: EventType): boolean {
	return ['virtual_presentation', 'physical_presentation'].includes(eventType);
}
